import {FormSubmitButton} from '@macmillanplatform/ui-core';
import type {
  FormSubmitButtonProps,
  OnClickHandler,
} from '@macmillanplatform/ui-core/types';

import {privacyLink} from '@/config';

import './index.css';

interface AuthFooterProps {
  isValid?: boolean;
  isSubmitting?: boolean;
  errors?: FormSubmitButtonProps['errors'];
  toggle: OnClickHandler;
}

const AuthFooter = (props: AuthFooterProps) => {
  const {isValid, isSubmitting, errors, toggle} = props;

  return (
    <section className="AuthFooter">
      <div className="AuthFooter__container">
        <div className="AuthFooter__hint">
          <p className="AuthFooter__hint-text">
            Enter your account number and zip code to log in. If you are a
            Canadian or international customer, please remember to enter only
            the first 5 characters of your zip code, including any spaces.
          </p>
          <div className="AuthFooter__links">
            <a
              className="AuthFooter__privacy-link"
              href={privacyLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Notice
            </a>
            |
            <a className="AuthFooter__contact-link" onClick={toggle}>
              Contact Us
            </a>
          </div>
        </div>

        <FormSubmitButton disabled={!isValid || isSubmitting} errors={errors}>
          Submit
        </FormSubmitButton>
      </div>
    </section>
  );
};

export default AuthFooter;
